import { Typography } from "@mui/material";
import { Fragment } from "react";

const AuthHeader = ({ header }) => {
  return (
    <Fragment>
      <Typography variant="h4" color="#99CCFF" fontWeight={500}>
        {header}
      </Typography>
    </Fragment>
  );
};

export default AuthHeader;
